<template>
    <div>
        <transition appear name="loading-bar">
            <loading-bar v-show="pending" />
        </transition>

        <b-card-body v-if="!pending && !items.length">
            <no-results-found class="mb-0" />
        </b-card-body>

        <services-to-complete-item
            v-for="(service, index) in items"
            :key="service.id"
            :api-url="`/api/projects/${projectId}/services_to_complete`"
            :project-id="projectId"
            :value="service"
            class="mx-2"
            @completed="handleCompleted($event, index)"
        />
    </div>
</template>

<script>
    import fetchData from '@/mixins/fetchData';
    import ServicesToCompleteItem from "@/components/ServicesToCompleteItem";

    export default {
        name: 'ProjectServicesToCompleteTab',
        components: {ServicesToCompleteItem},
        mixins: [fetchData],
        props: {
            projectId: {
                type: [String, Number],
                required: true,
            },
        },
        data() {
            return {
                showCollapse: false,
            };
        },
        computed: {
            apiUrl() {
                return `/api/projects/${this.projectId}/services`;
            },

            servicesCompletedCount() {
                return this.items.filter(service => {
                    if (!service.completed_steps) return false;

                    return service.steps === service.completed_steps.length;
                }).length;
            },
        },

        methods: {
            handleCompleted(data, index) {
                this.items[index].completed_steps = this.items[index].completed_steps || [];
                this.items[index].completed_steps.push(data);
            },
        }
    };
</script>

<style lang="scss" scoped>
    @import 'resources/sass/variables';

    .card {
        margin-top: $spacer * 0.5;

        &:last-child {
            margin-bottom: $spacer * 0.5;
        }
    }

</style>
